__turbopack_context__.v({
  "wrapper": "styles-module__ZYTWdW__wrapper",
  "wrapper--full": "styles-module__ZYTWdW__wrapper--full",
  "wrapper--gridMaxWidth": "styles-module__ZYTWdW__wrapper--gridMaxWidth",
  "wrapper--narrow": "styles-module__ZYTWdW__wrapper--narrow",
});
